/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Divider } from '@material-ui/core';
import {
	Button,
	Input,
	Pager,
	Select,
	SideModal,
	Typography,
} from 'design_system/src';

import { ReactComponent as Search } from 'design_system/src/static/icons/search.svg';
import { ReactComponent as Position } from 'design_system/src/static/icons/gps.svg';

import { Device } from 'models/geozon/interfaces/device.interface';
import { fetchDevices } from 'models/geozon/controllers/device.controller';
import { TileTracker } from 'models/geozon/interfaces/tile.interface';
import {
	fetchTiles,
	syncTiles,
} from 'models/geozon/controllers/tile.controller';
import { toasterOptions } from 'models/shared/enums/toaster.enum';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { commonErrorHandler } from 'models/shared/helpers/errors';

interface SelectDeviceModalProps {
	open: boolean;
	setOpen: (open: boolean) => void;
	type: boolean;
	assignDevice: (device: Device | TileTracker) => void;
}
function SelectDeviceModal({
	open,
	setOpen,
	type,
	assignDevice,
}: SelectDeviceModalProps) {
	const [devices, setDevices] = useState<(Device | TileTracker)[]>([]);

	const [queryDevices, setQueryDevices] = useState('');
	const [loadingDevices, setLoadingDevices] = useState<boolean>(false);
	const [loadingSync, setLoadingSync] = useState<boolean>(false);

	const [count, setCount] = useState(0);
	const [totalPages, setTotalPages] = useState<number>(0);
	const [currentPage, setCurrentPage] = useState<number>(1);

	const closeDevices = () => {
		setCurrentPage(1);
		setDevices([]);
		setQueryDevices('');
		setOpen(false);
	};

	const getDevices = () => {
		setLoadingDevices(true);

		(type ? fetchDevices : fetchTiles)({
			page: currentPage,
			limit: 30,
			query: queryDevices,
			hasVehicle: 'false',
		}).then((info: any) => {
			setLoadingDevices(false);
			setDevices(info.data);
			setTotalPages(info.pages);
			setCount(info.count);

			setCurrentPage(1);
		});
	};

	const sincronizarTile = () => {
		setLoadingSync(true);
		syncTiles()
			.then((result) => {
				setLoadingSync(false);
				toasterNotification({
					msg: `Se han agregado ${result.created} Tiles`,
					toasterType: toasterOptions.success,
					style: 'light',
				});
				getDevices();
			})
			.catch((e) => {
				setLoadingSync(false);
				commonErrorHandler(e);
			});
	};

	useEffect(() => getDevices(), [currentPage]);

	return open ? (
		<SideModal open={open} setOpen={closeDevices} size="normal">
			<div className="flex_content_col">
				<div className="flex_header">
					<Typography
						scale="heading4"
						weight="600"
						textColor="neutral_900"
						className="m_b_md"
					>
						Asignar {type ? 'GPS' : 'Tile'}
					</Typography>
					<Divider />
					<div className="display_flex flex_gap_md w_100_per flex_align_center">
						<Input
							title=""
							placeholder="Búsqueda"
							className="flex_1"
							name="search"
							type="text"
							value={queryDevices}
							onChange={(e: any) => setQueryDevices(e.target.value)}
						/>
						<Button
							type="submit"
							scale="small"
							icon={<Search />}
							className=""
							onClick={getDevices}
							variant="icon"
							subvariant="fill"
						/>
					</div>
				</div>
				<div className="flex_body p_r_xs">
					{loadingDevices ? (
						<Typography scale="medium" weight="400" textColor="neutral_900">
							Cargando Dispositivos
						</Typography>
					) : devices?.length ? (
						<div className="display_flex flex_col flex_gap_xs">
							{devices.map((dev: any) => (
								<div
									className="br_xs border_1 border_solid border_neutral_400 p_md display_flex flex_gap_md flex_align_center cursor_pointer"
									key={dev._id}
									role="button"
									onClick={() => {
										closeDevices();
										assignDevice(dev);
									}}
									onKeyDown={() => {
										closeDevices();
										assignDevice(dev);
									}}
									tabIndex={0}
								>
									<Position className="dim_md" />
									{type ? (
										<>
											<Typography scale="medium" weight="400" className="">
												IMEI: {dev.imei ?? '--'}
											</Typography>
											<Typography
												scale="medium"
												weight="600"
												className="flex_1 text_right"
											>
												{dev.phone ?? '--'}
											</Typography>
										</>
									) : (
										<>
											<Typography scale="medium" weight="400" className="">
												UUID: {dev.uuid ?? '--'}
											</Typography>
											<Typography
												scale="medium"
												weight="600"
												className="flex_1 text_right"
											>
												{dev.name ?? '--'}
											</Typography>
										</>
									)}
								</div>
							))}
						</div>
					) : (
						<div className="display_flex flex_col flex_gap_md flex_align_center">
							<Typography scale="medium" weight="400" textColor="neutral_900">
								{type
									? 'No se encontraron dispositivos'
									: 'No se encontraron dispositivos, si se registraron nuevos, porfavor sincronizalos'}
							</Typography>
							{!type && (
								<Button
									scale="small"
									onClick={sincronizarTile}
									disabled={loadingSync}
								>
									Sincronizar Tiles
								</Button>
							)}
						</div>
					)}
				</div>
				<div className="flex_footer">
					<Pager
						totalPages={totalPages}
						setPage={setCurrentPage}
						page={currentPage}
						count={count}
						className="w_fit"
					/>
				</div>
			</div>
		</SideModal>
	) : null;
}

export default SelectDeviceModal;
